import { render, staticRenderFns } from "./QSmsCorrespondenceDialog.vue?vue&type=template&id=2a3d2331&"
import script from "./QSmsCorrespondenceDialog.vue?vue&type=script&lang=js&"
export * from "./QSmsCorrespondenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports